import React from 'react';
import './blog.css'
import blogimg from '../images/news (1).jpg'
import BlodData from './BlogData'
import { Typography, Row, Col, Card, Button } from 'antd';
import { CalendarOutlined, UserOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;


function Blog() {
    return (
        <div className="blog-contaier" id="blogs">
        <div className="latest-news-main">
        <div className="blog-heading-container">
                <Text className="blog-paragraph">
                    {/* <p>
                         POPULAR POSTS
                    </p> */}
                </Text>
                <Title className="sectionHeading-blog">Latest Posts</Title>
            </div>
            <div>
                <Row justify="center" className="news-main-row" gutter={{ xs: 32, sm: 18, md: 48, lg: 19, xl: 32 }} >
                    <Col className="news-left-col" xs={22} sm={20} md={22} lg={11} xl={12}>
                        <div>
                            <Card
                                hoverable
                                cover={<img alt="example" src={blogimg} />}
                            >
                                <CalendarOutlined style={{ color: '#0A4A78', fontSize: '15px' }} />
                                <span className="news-date">5 April 2020</span>
                                <UserOutlined style={{ color: '#0A4A78', fontSize: '15px', paddingLeft: '20px' }} />
                                <span className="news-admin-name">By Admin</span>

                                <h1 className="news-left-col-title"> Astronomers discover brightest supernova ever seen </h1>
                                <Text className="news-left-col-paragraph">
                                    <p>
                                        A supernova is the explosion that occurs in the final throes of
                                        a dying, powerful star – with some of the largest thought to cause
                                        black holes to form.A supernova is the explosion that occurs in the
                                        final throes ofa dying, powerful star – with some of the largest thought
                                        to cause black holes to form.
                                    </p>
                                    <Button className="letest-new-view-more" size='large' >Read More </Button>
                                </Text>
                            </Card>
                        </div>
                    </Col>

                    <Col className="news-right-col" xs={23} sm={20} md={22} lg={11} xl={11}>
                       
                            {BlodData.map(blog =>
                                <div key={blog.id}>
                                    <Row justify="center" className="news-right-inner-row" gutter={{ xs: 6, sm: 20, md: 48, lg: 18, xl: 32 }} >
                                        <Col className="letest-new-image" xs={24} sm={8} md={8} lg={10} xl={10}>
                                            <img alt="example" src={blog.img} />
                                        </Col>
                                        <Col className="Letest-News-inner-right" xs={24} sm={16} md={16} lg={14} xl={14}>
                                            <div className="right-date-admin-name">
                                                <CalendarOutlined style={{ color: '#0A4A78', fontSize: '15px' }} />
                                                <span className="news-date">{blog.published}</span>
                                                <UserOutlined style={{ color: '#0A4A78', fontSize: '15px', paddingLeft: '20px' }} />
                                                <span className="news-admin-name">{blog.publishedBy}</span>
                                            </div>
                                            <h1 className="news-right-col-title"> {blog.title}  </h1>
                                            <Text>
                                                <p className="news-right-col-paragraph">
                                                    {blog.description}
                                                </p>
                                            </Text>
                                        </Col>

                                    </Row>
                                </div>
                            )}
                       
                    </Col>
                </Row>
            </div>
         </div>                            
    </div>

    )
}


export default Blog;
